define.alias("shared/components/shared/video-player", "media/components/shared/video-player");